import React from 'react';

export class HDivider extends React.Component<{}> {
    render(): React.ReactNode {
        return (
            <div className='h-divider'></div>
        )
    }
}